export default "__VITE_ASSET__Dc8301kj__"